<mat-expansion-panel [expanded]="true" showToggle="false" class="matExpansion-selected">
  <mat-expansion-panel-header class="disable_ripple">
    <mat-panel-title>
      <b class="disable_ripple_font">ELEMENTARY (CURRENTLY ENROLLED IN GRADES K-8): ACADEMIC REVIEW </b>
	  <help-text-btn class="align-help-text-btn" [helpTextId]="'InaIlp_Elementary_Overview'"></help-text-btn>
    </mat-panel-title>

  </mat-expansion-panel-header>

  <form [formGroup]="frmElementary">
    
    <div class="row">
      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-8 col-xl-8">            
        <!--Language Art, Math , ELPAC-->
        <div class="row">
          <div class="col">
            <mat-label><b>Language Arts</b>
				<help-text-btn class="align-help-text-btn" [helpTextId]="'InaIlp_Elementary_LanguageArts'"></help-text-btn>
			</mat-label>
          </div>
          <div class="col">
            <mat-label><b>Math</b>
				<help-text-btn class="align-help-text-btn" [helpTextId]="'InaIlp_Elementary_Math'"></help-text-btn>
			</mat-label>
          </div>
          <div class="col">
            <mat-label><b>ELPAC</b>
				<help-text-btn class="align-help-text-btn" [helpTextId]="'InaIlp_Elementary_ELPAC'"></help-text-btn>
			</mat-label>
          </div>
        </div>
        <!--Year-->
        <div class="row" style="padding-top: 10px">
          <div class="col-4">
            <mat-label>Year : {{this.lYear}}</mat-label>
          </div>
          <div class="col-4">
            <mat-label>Year : {{this.mYear}}</mat-label>
          </div>
          <div class="col-4">
            <mat-label>Year : {{this.eYear}}</mat-label>
          </div>
        </div>
        <!--Assessed Grade-->
        <div class="row" style="padding-top: 10px">
          <div class="col-4">
            <mat-label>Assessed Grade: {{this.lGrade}}</mat-label>
          </div>
          <div class="col-4">
            <mat-label>Assessed Grade: {{this.mGrade}}</mat-label>
          </div>
          <div class="col-4">
            <mat-label>Assessed Grade: {{this.eGrade}}</mat-label>
          </div>
        </div>
        <!--Standard Met or Exceeded Proficient-->
        <div class="row" style="padding-top: 10px">
          <div class="col-4">
            <div class="row">
              <div class="col">
                <mat-label>Standard Met or Exceeded &NonBreakingSpace;</mat-label>
              </div>

              <mat-radio-group aria-label name="radioArtStandardMet" formControlName="radioArtStandardMet"
                id="radioArtStandardMet">
                <div class="col">
                  <mat-radio-button [color]="'primary'" class="example-radio-button" value="1">Yes</mat-radio-button>
                </div>
                <div class="col">
                  <mat-radio-button [color]="'primary'" class="example-radio-button" value="2">No</mat-radio-button>
                </div>
              </mat-radio-group>
            </div>
          </div>
          <div class="col-4">
            <div class="row">
              <div class="col">
                <mat-label>Standard Met or Exceeded &NonBreakingSpace;</mat-label>
              </div>
              <mat-radio-group aria-label name="radioMathStandardMet" formControlName="radioMathStandardMet"
                id="radioMathStandardMet">
                <div class="col">
                  <mat-radio-button [color]="'primary'" class="example-radio-button" value="1">Yes</mat-radio-button>
                </div>
                <div class="col">
                  <mat-radio-button [color]="'primary'" class="example-radio-button" value="2">No</mat-radio-button>
                </div>
              </mat-radio-group>
            </div>
          </div>
          <div class="col-4">
            <div class="row">
              <div class="col">
                <mat-label>Proficient &NonBreakingSpace;</mat-label>
              </div>
              <mat-radio-group aria-label name="radioProficient" formControlName="radioProficient" id="radioProficient">
                <div class="col">
                  <mat-radio-button [color]="'primary'" class="example-radio-button" value="1">Yes</mat-radio-button>
                </div>
                <div class="col">
                  <mat-radio-button [color]="'primary'" class="example-radio-button" value="2">No</mat-radio-button>
                </div>
              </mat-radio-group>
            </div>
          </div>
        </div>
      </div>
      
      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-3 col-xl-3">      
        <div class="row" >
          <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <mat-label><b>Comments</b>
				<help-text-btn class="align-help-text-btn" [helpTextId]="'InaIlp_Elementary_Comments'"></help-text-btn>
            </mat-label>
          </div>
          <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <mat-form-field appearance="outline">
              <mat-label><b>Comments</b></mat-label>
              <textarea matInput rows="7" cols="50" type="string" formControlName="languageComments" 
                (focusout)="updateChangeValueLostFocus()">
              </textarea>
            </mat-form-field>

          </div>
        </div>
      </div>
    </div>



    <div style="padding-top: 30px"></div>


  </form>

  <div class="row" *ngIf="(action==2 || action==3) ">
    <mat-accordion>
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>
            Past Edit - {{this.trackHistories.inaHistory.length}}
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div *ngIf="this.trackHistories.inaHistory.length>=1">
          <app-past-edit [section]="this.section"></app-past-edit>
        </div>
      </mat-expansion-panel>
    </mat-accordion>
  </div>
</mat-expansion-panel>